var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    width: 400,
    height: 410,
    viewBox: "0, 20, 400, 420",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 570,
    height: 510,
    fill: "#000000",
    fillOpacity: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)",
    "data-name": "G",
    "data-color": "#fb0094",
    className: "layer isolate-layer g",
    "data-custom-element": "GroupEditing_layer",
    active: ""
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127 333 l-107 -108 103 -103 c56 -56 106 -102 110 -102 4 0 7 12 7 28 0 21 -18 45 -75 102 l-75 75 76 76 c66 67 75 80 72 108 l-3 32 -108 -108z",
    fill: "#11253F",
    strokeWidth: 24,
    strokeMiterlimit: 10,
    stroke: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    transform: "matrix(1 0 0 1 -0.144997 -0.733002)",
    className: "",
    selected: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286 188 c-51 -51 -57 -62 -45 -74 13 -12 23 -5 78 50 57 58 71 88 38 85 -7 -1 -38 -28 -71 -61z",
    fill: "#E62E2D",
    strokeWidth: 24,
    strokeMiterlimit: 10,
    stroke: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    transform: "matrix(-0.027745 -0.999615 0.999615 -0.027745 28.4969 486.372)",
    className: "",
    selected: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286 188 c-51 -51 -57 -62 -45 -74 13 -12 23 -5 78 50 57 58 71 88 38 85 -7 -1 -38 -28 -71 -61z",
    fill: "#E62E2D",
    strokeWidth: 24,
    strokeMiterlimit: 10,
    stroke: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    transform: "matrix(-0.027745 -0.999615 0.999615 -0.027745 73.4248 535.759)",
    className: "",
    selected: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286 188 c-51 -51 -57 -62 -45 -74 13 -12 23 -5 78 50 57 58 71 88 38 85 -7 -1 -38 -28 -71 -61z",
    fill: "#E62E2D",
    strokeWidth: 24,
    strokeMiterlimit: 10,
    stroke: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    transform: "matrix(-0.027745 -0.999615 0.999615 -0.027745 125.696 584.588)",
    className: "",
    selected: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f890f4e5df7f318be8c54def469032a7.svg";
export { ForwardRef as ReactComponent };